export default {
  authUpdate: 'パスワードが変更されました',
  authForgot: 'パスワード再発行メールを送信しました',
  authRegist: '新しいパスワードが登録されました',
  personalUpdate: 'ユーザー設定が更新されました',
  postsAdd: '掲示板に投稿されました',
  postsUpdate: '掲示板の投稿が更新されました',
  postsDelete: '掲示板の投稿が削除されました',
  productsAdd: '製品情報が登録されました',
  productsUpdate: '製品情報が更新されました',
  productsDelete: '製品情報が削除されました',
  productsPublic: '製品情報が公開に変更されました',
  productsFinish: '製品情報が済に変更されました',
  productsCancel: '製品情報が取消に変更されました',
  productsInquiry: '問い合わせが送信されました',
  uploadsUpload: 'ファイルがアップロードされました',
  uploadsDelete: 'ファイルが削除されました',
  usersAdd: 'ユーザーを登録しました',
  usersUpdate: 'ユーザーを更新しました',
  usersDelete: 'ユーザーを削除しました',
  usersCode: '招待メールを送信しました',
};
